module.exports = __webpack_public_path__ + "img/THINDFDF-1024x743-1-thegem-portfolio-masonry-img12.644879d2.png";